import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { FiltersTypes } from "@common/types/filters/general";
import { documentCategoryContract } from "@common/contracts/document-category.contract";
import { useScope } from "@state/scopeContext.lib";
import { getBackendAPIClient } from "@lib/backendAPIClient";

const documentCategoryContractClient = getBackendAPIClient(
    documentCategoryContract,
);

export function useDocumentCategoryStatistics(
    filters: Pick<FiltersTypes, "entityIds" | "start" | "end">,
) {
    const { workspaceId } = useScope();

    if (!workspaceId) {
        throw new Error("No active workspace");
    }

    return useQuery({
        queryKey: ["documentCategoryStatistics", filters],
        queryFn: () =>
            documentCategoryContractClient.getDocumentCategoryStatistics({
                query: {
                    entityIds: filters.entityIds,
                    start: filters.start,
                    end: filters.end,
                },
                params: { workspaceId },
            }),
        placeholderData: keepPreviousData,
    });
}
